<script>
    export let x;
    export let y;
    export let shiftOrigin = false;

    let color = Math.random() < 0.5 ? "#DB2955" : "#499167";
    let size = 60 + Math.random() * 40;
</script>

<div class="shape-wrapper" style="top: {y};
        left: {x};">
    <div
        class="shape"
        class:shift-origin={shiftOrigin}
        style="background-color: {color};
        width: {size}px;
        height: {size}px"
    />
</div>

<style>
    .shape-wrapper {
        position: absolute;
    }

    .shift-origin {
        left: -100%;
    }

    .shape {
        position: relative;
        border-radius: 100%;
    }

    .shape-wrapper:hover .shape {
        animation: bounce 0.4s ease-out forwards;
    }
</style>
